<template>
  <div class="overlay">
    <div class="modal">
      <h1 class="header-title">
        No access
      </h1>
      <p>The CRS dashboard has now closed.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RareLoadingOverlay',
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  h1, p {
    color: #323c44;
  }

  .overlay {
    pointer-events: auto;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 9999;
  }

  .modal {
    padding: 30px;
    width: 600px;
    max-width: 70%;
    height: auto;
    background-color: white;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    border: 1px solid #7d8b96;
    border-radius: 5px;
  }
</style>
